<template>
  <md-field :md-toggle-password="false" :class="[fieldClass, 'password-field', 'md-has-password']">
    <slot name="label" />
    <md-input
      :style="inputStyle"
      :type="visible ? 'text' : 'password'"
      :name="name"
      :id="id"
      :value="value"
      :disabled="disabled"
      @input="$emit('input', $event)"
    />
    <md-button
      v-if="!nojs"
      tabindex="-1"
      type="button"
      class="md-icon-button md-dense md-input-action md-toggle-password"
      :aria-label="visible ? 'Hide password' : 'Show password'"
      @click="visible = !visible"
    >
      <md-icon>{{ visible ? 'visibility_off' : 'visibility' }}</md-icon>
    </md-button>
    <slot />
  </md-field>
</template>

<script>
  export default {
    name: 'PasswordField',
    props: {
      id: {
        type: String,
        required: true
      },
      name: {
        type: String,
        required: true
      },
      value: {
        default: null
      },
      disabled: {
        type: Boolean,
        default: false
      },
      fieldClass: {
        default: null
      },
      nojs: {
        type: Boolean,
        default: false
      },
      inputStyle: {
        default: null
      }
    },
    data: () => ({
      visible: false
    }),
    watch: {
      value (value) {
        if (!value) {
          this.visible = false
        }
      }
    }
  }
</script>
